import type { UploadProgress } from '../api/types'

/** A gap between checkpoint retries must not freeze an unfinished status. */
export function materialNeedsRefresh(revision:UploadProgress){
 const material=revision.processing?.material;
 return uploadProgress(revision).active||Boolean(material&&(material.status!=='ready'||material.upgrade_required||material.source_upgrade_pending));
}

export function uploadProgress(revision: UploadProgress) {
  const state = revision.processing?.status ?? (
    ['abandoned', 'superseded', 'effective', 'rejected', 'returned', 'withdrawn', 'expired', 'quarantined'].includes(revision.status) ? 'completed'
      : ['pending_approval', 'approved', 'approved_partial'].includes(revision.status) ? 'review'
        : revision.parse_status === 'failed' ? 'failed'
          : revision.status === 'diff_review' ? 'ready' : 'queued')
  const matching = revision.processing?.stage === 'diff'
  const copy = {
    queued: ['等待解析', '已上传，正在排队；可离开页面，稍后回来查看。', 'blue'],
    running: [matching ? '正在生成差异' : '正在解析', matching ? '页面已解析，正在与基线逐页比对，完成后可处理差异。' : '正在转换 PPT、生成页面预览，完成后自动更新。', 'blue'],
    retrying: ['正在自动重试', '后台正在重新处理，无需重复上传。', 'orange'],
    ready: ['待处理差异', '解析和差异识别已完成，可继续选择基线页面。', 'orange'],
    failed: ['处理失败', '文件已保留，请联系管理员检查解析任务，无需重复上传。', 'red'],
    cancelled: ['处理已取消', '后台处理已取消，请联系管理员确认。', 'grey'],
    review: ['待审核', '页面已提交审核，确认通过后更新基线。', 'orange'],
    completed: ['已结束', '该上传文件已结束处理，可预览原始页面。', 'grey'],
  } as const
  let [label, hint, tone]:[string,string,typeof copy[typeof state][2]] = [...copy[state]]
  const material=revision.processing?.material
  if(revision.processing?.material_active&&material){label=({vision:'正在识别图文',understanding:'正在分析材料',embedding:'正在准备检索',checking:'正在检查处理结果'} as Record<string,string>)[material.status]??label;hint=`共 ${material.page_count??material.total} 个来源页面／位置，图文识别 ${material.vision.completed}/${material.vision.total}，内容分析 ${material.understanding.completed}/${material.understanding.total}；结果自动保存，可稍后回来查看。`}
  const active = ['queued', 'running', 'retrying'].includes(state)||Boolean(revision.processing?.material_active)
  const preview = (revision.page_count ?? 0) > 0 && (revision.parse_status === 'success' || state === 'completed' || state === 'ready' || state === 'review')
  return { state, label, hint, tone, active, preview, ready: state === 'ready' }
}
